import React, { FC, useState } from "react";

import "./CategorySidebar.css";
import Line from "../Line/Line";
import Checkbox from "../Checkbox/Checkbox";
import SizeButton from "../SizeButton/SizeButton";
import MultiRangeSlider from "../MultiRangeSlider/MultiRangeSlider";
import { useCategorySidebarData } from "../../hooks/api/useCategorySidebarData";

interface ICategorySidebar {
  shoesSizeIds: number[];
  brandIds: number[];
  prices: number[];
  handleChange: (
    type: "brandIds" | "prices" | "shoesSizeIds",
    value: number | number[]
  ) => void;
}

const CategorySidebar: FC<ICategorySidebar> = ({
  handleChange,
  brandIds,
  prices,
  shoesSizeIds,
}) => {
  const { data } = useCategorySidebarData();
  const [isOpen, setIsOpen] = useState(false);

  if (!data?.data) return null;

  const { amounts, brands, sizes } = data.data.attributes.sidebar;

  const activeCount =
  brandIds.length + shoesSizeIds.length + (prices.length > 0 ? 1 : 0);

  const content = (
    <>
      <div className="cat-sidebar__wrapper">
        <h4 className="cat-sidebar__title">{brands.title}</h4>
        <div className="cat-sidebar__brands">
          {brands.brands.data.map(({ attributes, id }) => (
            <Checkbox
              key={id}
              checked={brandIds.some((b) => b === id)}
              label={attributes.name}
              onChange={() => handleChange("brandIds", id)}
            />
          ))}
        </div>
      </div>
      <Line />
      <div className="cat-sidebar__wrapper">
        <h4 className="cat-sidebar__title">
          {data.data.attributes.sidebar.amounts.title}
        </h4>
        <MultiRangeSlider
          handleChange={(values) => handleChange("prices", values)}
          max={amounts.amount_to}
          min={amounts.amount_from}
          currency={amounts.currency.data.attributes.name}
        />
      </div>
      <Line />
      <div className="cat-sidebar__wrapper">
        <h4 className="cat-sidebar__title">
          {data.data.attributes.sidebar.sizes.title}
        </h4>
        <div className="cat-sidebar__sizes">
          {sizes.sizes.data.map(({ attributes, id }) => (
            <SizeButton
              key={id}
              selected={shoesSizeIds.some((s) => s === id)}
              label={attributes.size}
              onClick={() => handleChange("shoesSizeIds", id)}
            />
          ))}
        </div>
      </div>
    </>
  );

  return (
    <>
      {/* Десктоп */}
      <div className="cat-sidebar cat-sidebar--desktop">{content}</div>

      {/* Мобайл — кнопка фільтрів */}
      <button
        className="cat-sidebar__fab"
        onClick={() => setIsOpen(true)}
      >
        <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
          <path d="M4 6h16M7 12h10M10 18h4" stroke="currentColor"
            strokeWidth="2" strokeLinecap="round"/>
        </svg>
        Фільтри
        {activeCount > 0 && (
          <span className="cat-sidebar__fab-badge">{activeCount}</span>
        )}
      </button>

      {/* Мобайл — drawer */}
      {isOpen && (
        <div className="cat-sidebar__overlay" onClick={() => setIsOpen(false)} />
      )}
      <div className={`cat-sidebar cat-sidebar--drawer ${isOpen ? "cat-sidebar--drawer-open" : ""}`}>
        <div className="cat-sidebar__drawer-header">
          <span className="cat-sidebar__drawer-title">Фільтри</span>
          <button
            className="cat-sidebar__drawer-close"
            onClick={() => setIsOpen(false)}
          >
            ✕
          </button>
        </div>
        <div className="cat-sidebar__drawer-content">
          {content}
        </div>
        <div className="cat-sidebar__drawer-footer">
          <button
            className="cat-sidebar__apply-btn"
            onClick={() => setIsOpen(false)}
          >
            Застосувати
          </button>
        </div>
      </div>
    </>
  );
};

export default CategorySidebar;